import Vue from 'vue/dist/vue.esm';
import agreement from './modules/agreement';
import loader from './modules/loader';
import noticeModal from './modules/notice_modal';
import yesnoModal from './modules/yesno_modal';
import sellers from "./modules/sellers";
import buyers from "./modules/buyers";
import paymentForm from "./modules/payment_form";
import auto from "./modules/auto";

import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    agreement,
    loader,
    noticeModal,
    yesnoModal,
    sellers,
    buyers,
    paymentForm,
    auto
  },
});

